import { SortableFilter }          from './../common/sortable-filter';

export class BusSortableFilter extends SortableFilter {
    public activeOnly = true;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/bus-list/bus-sortable-filter.ts